import PropTypes from 'prop-types';
import React from 'react';

import styles from './auth-forms.css';

class LoginForm extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            error: '',
            busy: false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange (e) {
        this.setState({[e.target.name]: e.target.value, error: ''});
    }
    handleSubmit (e) {
        e.preventDefault();
        const {username, password} = this.state;
        if (!username || !password) {
            this.setState({error: 'Заполните все поля'});
            return;
        }
        this.setState({busy: true, error: ''});
        this.props.onSubmit(username, password)
            .then(() => {
                this.setState({busy: false});
                if (this.props.onClose) this.props.onClose();
            })
            .catch(err => {
                this.setState({busy: false, error: err.message || 'Ошибка входа'});
            });
    }
    render () {
        return (
            <form className={styles.form} onSubmit={this.handleSubmit}>
                <label className={styles.label}>
                    Имя пользователя
                    <input
                        autoComplete="username"
                        className={styles.input}
                        name="username"
                        type="text"
                        value={this.state.username}
                        onChange={this.handleChange}
                    />
                </label>
                <label className={styles.label}>
                    Пароль
                    <input
                        autoComplete="current-password"
                        className={styles.input}
                        name="password"
                        type="password"
                        value={this.state.password}
                        onChange={this.handleChange}
                    />
                </label>
                {this.state.error ? <div className={styles.error}>{this.state.error}</div> : null}
                <button
                    className={styles.button}
                    disabled={this.state.busy}
                    type="submit"
                >
                    {this.state.busy ? 'Вход…' : 'Войти'}
                </button>
            </form>
        );
    }
}

LoginForm.propTypes = {
    onClose: PropTypes.func,
    onSubmit: PropTypes.func.isRequired
};

export default LoginForm;
